import React, { useState } from "react";
import {
  Tabs,
  Card,
  Row,
  Col,
  Typography,
  Space,
  Button,
  Tag,
  Badge
} from "antd";
import {
  BankOutlined,
  MoneyCollectOutlined,
  ApartmentOutlined,
  SettingOutlined,
  DatabaseOutlined,
  SecurityScanOutlined, // For FING (fingerprint alternative)
  GlobalOutlined, // For DMT alternative
  PartitionOutlined
} from "@ant-design/icons";
import DMTBankManagement from "./BankManagement";
import FINGBankManagement from "./FINGBankManagement";
import InstantPayAEPSBanks from "./InstantPayBanks";

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const BankManagementTabs = ({ history }) => {
  const [activeTab, setActiveTab] = useState("dmt");
  const [bankStats, setBankStats] = useState({
    dmt: { total: 0, active: 0 },
    fing: { total: 0, active: 0 }
  });

  const updateBankStats = (type, stats) => {
    setBankStats(prev => ({
      ...prev,
      [type]: stats
    }));
  };

  const tabItems = [
    {
      key: "dmt",
      label: (
        <Space>
          <MoneyCollectOutlined />
          DMT Banks
          <Badge
            count={bankStats.dmt.total}
            style={{
              backgroundColor: bankStats.dmt.total > 0 ? '#52c41a' : '#d9d9d9',
              marginLeft: 8
            }}
          />
        </Space>
      ),
      children: <DMTBankManagement history={history} onStatsUpdate={(stats) => updateBankStats('dmt', stats)} />
    },
    {
      key: "fing",
      label: (
        <Space>
          <SecurityScanOutlined />
          FING Banks
        </Space>
      ),
      children: <FINGBankManagement history={history} onStatsUpdate={(stats) => updateBankStats('fing', stats)} />
    },
    {
      key: "instantpay",
      label: (
        <Space>
          <GlobalOutlined />
          Instant Pay Banks
        </Space>
      ),
      children: <InstantPayAEPSBanks history={history} onStatsUpdate={(stats) => updateBankStats('instantpay', stats)} />
    }

  ];



  return (
    <div
      style={{
        background: "#f8fafc",
        minHeight: "100vh",
        padding: 24
      }}
    >
      <div style={{ maxWidth: 1600, margin: "0 auto" }}>
        {/* HEADER */}

        {/* MAIN TABS */}
        <Card
          bordered={false}
          style={{
            borderRadius: "16px",
            background: "rgba(255, 255, 255, 0.9)",
            boxShadow: "0 4px 24px rgba(0,0,0,.06)"
          }}
          bodyStyle={{ padding: 0 }}
        >
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            type="card"
            size="large"
            style={{
              padding: "0 24px",
              paddingTop: 16
            }}
            tabBarStyle={{
              marginBottom: 0,
              borderBottom: "none"
            }}
          >
            {tabItems.map(item => (
              <TabPane
                key={item.key}
                tab={item.label}
                style={{ padding: 24 }}
              >
                {item.children}
              </TabPane>
            ))}
          </Tabs>
        </Card>
      </div>
    </div>
  );
};

export default BankManagementTabs;